import { useState } from 'react';

// Services

import ListsService from '../services/lists.service';

export default function CheckPersonalReferenceOnLists() {
    const [checkPersonalReferenceOnListIsLoading, setCheckPersonalReferenceOnListIsLoading] = useState(false);
    const [checkPersonalReferenceOnListError, setCheckPersonalReferenceOnListError] = useState(null);

    // Consult if the personal reference is on the internal or international lists

    const handleCheckPersonalReferenceOnLists = async (internalListData, internationalListData, handleSetisOnList) => {
        setCheckPersonalReferenceOnListIsLoading(true);
        setCheckPersonalReferenceOnListError(null);

        try {
            const response = await ListsService.consultaListasInternas(internalListData);
          
            if (response.data?.data?.codigoError === "0") {
                const intListResponse = await ListsService.consultaListasInternacionales(internationalListData);
                
                if (intListResponse?.data?.data?.codigoError === "0") {
                    handleSetisOnList(false);
                }
            }
            
            setCheckPersonalReferenceOnListIsLoading(false);
 
        } catch(error) {
            setCheckPersonalReferenceOnListIsLoading(false);

            if (error.response?.status === 400 && error.response?.data?.data?.codigoError === '1') {
                handleSetisOnList(true);
            } else {
                setCheckPersonalReferenceOnListError(error.response?.data?.message || error.message);
            }
        }
    }

    return {
        checkPersonalReferenceOnListIsLoading,
        checkPersonalReferenceOnListError,
        handleCheckPersonalReferenceOnLists,
    }
}
